/** @format */

import banner1EN from "../../assets/Banner-EN1.png";
import banner2EN from "../../assets/Banner-EN2.png";
import banner3EN from "../../assets/Banner-EN3.png";

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "../../css/Banner.css";
import { propTypes } from "react-bootstrap/esm/Image";

export default function BannerTH(props) {
  const [lang, setLanguage] = useState(true);

  const changeLang = () => {
    props.onSelect(!lang);
    // setLanguage(!lang)
    // console.log(lang);
  };

  return (
    <div
      id="carouselExampleIndicators"
      class="col-sm-12 carousel slide mt-0"
      data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="0"
          class="active"
          aria-current="true"
          aria-label="Slide 1"></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="1"
          aria-label="Slide 2"></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="2"
          aria-label="Slide 3"></button>
      </div>
      <div class="carousel-inner" role="listbox">
        <div class="carousel-item active">
          <img
            className="banner"
            src={banner1EN}
            // class="d-block w-100 h-25 d-inline-block"
            alt="banner1TH"
          />
        </div>
        <div class="carousel-item">
          <img
            className="banner"
            src={banner2EN}
            // class="d-block w-100 h-25 d-inline-block"
            alt="banner2TH"
          />
        </div>
        <div class="carousel-item">
          <img
            className="banner"
            src={banner3EN}
            // class="d-block w-100 h-25 d-inline-block"
            alt="banner3TH"
          />
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  );
}
